/** The two layouts a page is designed for. */
export type Device = 'desktop' | 'mobile';

/**
 * Where a layout choice applies: on every device, or only on one of them. A
 * missing scope always means `all`, so every setting stored before devices
 * existed keeps meaning what it did.
 */
export type DeviceScope = 'all' | Device;

export const DEVICE_SCOPES: readonly DeviceScope[] = ['all', 'desktop', 'mobile'];

/** Tailwind's `sm` breakpoint, the same line the grid's toolbar and cards use. */
export const MOBILE_QUERY = '(max-width: 639.98px)';

export function isDeviceScope(value: unknown): value is DeviceScope {
  return value === 'all' || value === 'desktop' || value === 'mobile';
}

/** Whether a choice scoped to `scope` applies on `device`. */
export function scopeIncludes(scope: DeviceScope | null | undefined, device: Device): boolean {
  return !scope || scope === 'all' || scope === device;
}
